import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ManutencaoClienteConsulta, RequisicaoManutencaoClienteConsulta } from 'src/app/@shared/models/manutencao-cliente';
import { montarQueryString } from '../base/base.service';
import { CepResp } from '../manutencao-atores/manutencao-atores.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ManutencaoClienteService {

  constructor(private http: HttpClient) { }


  consultaClientes(obj: RequisicaoManutencaoClienteConsulta): Observable<ManutencaoClienteConsulta[]> {
    const filter = `${obj.codigo ? `codigo=${obj.codigo}&` : ''}` +
      `${obj.nome ? `nome=${obj.nome}&` : ''}` +
      `${obj.cnpj ? `cnpj=${obj.cnpj}&` : ''}` +
      `${obj.ativo ? `ativo=${obj.ativo}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<ManutencaoClienteConsulta[]>(
      `Cliente/manutencao/listar?${filter}`,
      httpOptions
    );
  }

  exportarClientes(obj: any): Observable<any> {
    const filter = `${obj.codigo ? `codigo=${obj.codigo}&` : ''}` +
      `${obj.nome ? `nome=${obj.nome}&` : ''}` +
      `${obj.cnpj ? `cnpj=${obj.cnpj}&` : ''}` +
      `${obj.ativo ? `ativo=${obj.ativo}` : ''}`;
    return this.http
      .get<any>(`Cliente/manutencao/exportar?${filter}`,
        httpOptions)

  }

  detalhesClientes(id?: number): Observable<any> {
    return this.http
      .get<any>(`Cliente/manutencao/detalhes/${id}`, httpOptions);
  }

  gravarCliente(obj?: any): Observable<any> {
    return this.http
      .post<any>(`Cliente/manutencao/inserir`, obj, httpOptions);
  }

  atualizarCliente(id?: any, obj?: any): Observable<any> {
    return this.http
      .put<any>(`Cliente/manutencao/alterar/${id}`, obj, httpOptions);
  }

  consultaCNPJ(cnpj?: any): Observable<any> {
    return this.http
      .get<any>(`Cliente/consultar/cnpj/${cnpj}`, httpOptions);
  }

  consultaCodigo(codigo?: any): Observable<any> {
    return this.http
      .get<any>(`Cliente/consultar/codigo/${codigo}`, httpOptions);
  }

  listarModalidadeFaturamento(): Observable<any> {
    return this.http
      .get<any>(`Cliente/ConsultarModalidadeFaturamento`, httpOptions) as Observable<any>
  }

  listarUF(): Observable<any> {
    return this.http
      .get<any>(`Cliente/consultarUF`, httpOptions) as Observable<any>
  }

  listarRomaneio(): Observable<any> {
    return this.http
      .get<any>(`TipoRomaneio/obtenhaTipoRomaneio`, httpOptions) as Observable<any>
  }

  consultaCEP(cep: string): Observable<CepResp[]> {
    return this.http.get<any>(`CEP/consultar/${cep}`);
  }

  getTipoNFCAll(): Observable<any[]> {
    return this.http.get<any[]>(`Produto/TipoNFC`);
  }

  getIntegracao(): Observable<any> {
    return this.http
      .get<any>(`Cliente/ConsultarControleOrigemApiIntegracao`, httpOptions) as Observable<any>
  }

  listarGrupoCliente(): Observable<any> {
    return this.http
      .get<any>(`Cliente/manutencao/consultagrupocliente`, httpOptions) as Observable<any>
  }

  listarTipoDevolucao(): Observable<any> {
    return this.http
      .get<any>(`Cliente/TipoDevolucao`, httpOptions) as Observable<any>
  }

  listarTipoCalculo(): Observable<any> {
    return this.http
      .get<any>(`Cliente/TipoCalculo`, httpOptions) as Observable<any>
  }

}
